import script from "./ScreenElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScreenElement.vue?vue&type=script&lang=ts&setup=true"

import "./ScreenElement.vue?vue&type=style&index=0&id=a15cc1d8&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a15cc1d8"]])

export default __exports__